<p-dialog
  [visible]="session.showWarningModal()"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="session-dialog no-header text-center">
  <div
    class="flex w-[462px] flex-col items-center gap-5 bg-surface-0 p-12 shadow-xl
      shadow-surface-200 rounded-border">
    <span
      class="flex h-12 w-12 items-center justify-center rounded-[28px] border-8
        border-[#FFFAEB] bg-[#FEF0C7]">
      <ng-icon
        name="phosphorInfo"
        size="24px"
        class="!text-yellow-600"></ng-icon>
    </span>
    <p class="font-heading text-2xl font-medium">
      Your session will expire soon
    </p>
    <p
      class="text-center font-body text-sm font-normal leading-[22px] text-slate-700">
      Your session will end due to inactivity in:
      <span class="font-medium text-slate-800">
        <ng-icon
          name="phosphorClock"
          class="pt-[2px] font-medium text-slate-800"
          size="15"></ng-icon>
        {{ session.countdown() }}s
      </span>
      <br />
      Click ‘<strong class="font-bold">Continue</strong>’ to remain logged in.
    </p>

    <div class="mt-4 flex w-full gap-3">
      <button pButton class="flex-1" (click)="session.manualLogout()" outlined>
        Log out
      </button>

      <button
        pButton
        class="flex-1"
        severity="primary"
        (click)="session.continueSession()">
        Continue
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog
  [visible]="session.showSessionEndedModal()"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="session-dialog no-header text-center">
  <div
    class="flex w-[462px] flex-col items-center gap-5 bg-surface-0 p-12 shadow-xl
      shadow-surface-200 rounded-border">
    <p class="font-heading text-2xl font-medium">Session ended</p>
    <p>
      Your session was closed after detecting more than 15 minutes of
      inactivity.
    </p>

    <div class="mt-4 flex w-full gap-3">
      <button
        pButton
        class="flex-1"
        severity="primary"
        (click)="session.finalizeFlow()">
        Continue
      </button>
    </div>
  </div>
</p-dialog>
